/**
 * Error codes for the Auth plugin.
 * @name authCodes
 */
export const authCodes = {
  INVALID_CREDENTIALS: 'authentication:1',
  CONNECT_FAIL_WS_ERROR: 'authentication:2',
  LINK_UNSUBSCRIBE_FAIL: 'authentication:3',
  LINK_SUBSCRIBE_FAIL: 'authentication:4',
  LINK_EXTEND_SUBSCRIPTION_FAIL: 'authentication:5',
  LINK_UPDATE_SUBSCRIPTION_FAIL: 'authentication:6',
  UC_SUBSCRIBE_FAIL: 'authentication:7',
  UC_REFRESH_TOKEN_FAIL: 'authentication:8',
  UC_CREATE_TOKEN_FAIL: 'authentication:9',
  UC_EXTEND_SUBSCRIPTION_FAIL: 'authentication:10',
  UC_DISCONNECT_FAIL: 'authentication:11',
  MISSING_SERVICE: 'authentication:12',
  LINK_SUBSCRIBE_UNAVAILABLE: 'authentication:13'
}

/**
 * Error codes for the Call plugin.
 * @name callCodes
 */
export const callCodes = {
  UNKNOWN_ERROR: 'call:1',
  GENERIC_ERROR: 'call:2',
  INIT_MEDIA_FAILED: 'call:3',
  USER_MEDIA_ERROR: 'call:4',
  NOT_SUPPORTED: 'call:5',
  // The call is in the wrong state.
  INVALID_STATE: 'call:6',
  // A provided parameter is not valid.
  INVALID_PARAM: 'call:7',
  // There is a desync between components' state.
  STATE_DESYNC: 'call:8',
  // Offer could not be generated
  INVALID_OFFER: 'call:9',
  // No ICE candidates found
  NO_ICE_CANDIDATES: 'call:10',
  // Failed to recieve answer due to media mismatch
  SESSION_MISMATCH: 'call:11'
}

/**
 * Error codes for the Call History plugin.
 * @name callHistoryCodes
 */
export const callHistoryCodes = {
  UNKNOWN_ERROR: 'callHistory:1',
  BAD_REQUEST: 'callHistory:2',
  NOT_FOUND: 'callHistory:3',
  NOT_AUTHENTICATED: 'callHistory:4',
  FORBIDDEN: 'callHistory:5'
}
/**
 * @name clickToCallCodes
 */
export const clickToCallCodes = {
  MISSING_ARGS: 'clickToCall:1',
  RESPONSE_ERROR: 'clickToCall:2'
}
/**
 * Error codes for the Groups plugin.
 * @name groupsCodes
 */
export const groupsCodes = {
  UNKNOWN_ERROR: 'groups:1',
  GENERIC_ERROR: 'groups:2',
  MISSING_PARAMETERS: 'groups:3'
}

/**
 * Error codes for the Message plugin.
 * @name messagingCodes
 */
export const messagingCodes = {
  CREATE_GROUP_FAIL: 'messaging:1',
  MARK_READ_FAIL: 'messaging:2',
  REMOVE_MEMBERS_FAIL: 'messaging:3',
  ADD_MEMBERS_FAIL: 'messaging:4',
  SEND_MESSAGE_FAIL: 'messaging:5',
  FETCH_MESSAGES_FAIL: 'messaging:6',
  FILE_UPLOAD_FAIL: 'messaging:7',
  FETCH_CONVERSATIONS_FAIL: 'messaging:8',
  INVALID_DESTINATION: 'messaging:9',
  INVALID_FILE_PARTS: 'messaging:10',
  SET_IS_TYPING_FAIL: 'messaging:11'
}

/**
 * Error codes for the Message Waiting Indicator plugin.
 * @name mwiCodes
 */
export const mwiCodes = {
  FETCH_MWI_FAIL: 'mwi:1'
}

/**
 * Error codes from the Sip Events plugin.
 * @name sipEventCodes
 */
export const sipEventCodes = {
  UNKNOWN_ERROR: 'sipEvents:1',
  // The user did not subscribe/connect for the specified sip event service.
  NOT_PROVISIONED: 'sipEvents:2',
  // The user is not subscribed for the specified sip event.
  NOT_SUBSCRIBED: 'sipEvents:3'
}

/**
 * Error codes for the audio bridge portion of the call plugin.
 * @name bridgeCodes
 */
export const bridgeCodes = {
  UNKNOWN_ERROR: 'audioBridge:1',
  // TODO: Make "invalid input" (and others) a generic code.
  INVALID_INPUT: 'audioBridge:2',
  ALREADY_EXISTS: 'audioBridge:3',
  NOT_FOUND: 'audioBridge:4',
  NOT_SUPPORTED: 'audioBridge:5',
  MEDIA_NOT_FOUND: 'audioBridge:6',
  INVALID_STATE: 'audioBridge:7'
}

/**
 * Error codes for the subscription plugin.
 * @name subscriptionCodes
 */
export const subscriptionCodes = {
  WS_CONNECTION_ERROR: 'subscription:1',
  CPAAS_WSREQUEST_FAIL: 'subscription:2',
  CPAAS_WSREVOKE_FAIL: 'subscription:3',
  CPAAS_WSREFRESH_FAIL: 'subscription:4',
  CPAAS_SERVICE_SUB_FAIL: 'subscription:5',
  CPAAS_SERVICE_UNSUB_FAIL: 'subscription:6',
  CPAAS_UNSUBSCRIBE_FAIL: 'subscription:7'
}

/**
 * Error codes for the connectivity plugin
 * @name connectivityCodes
 */
export const connectivityCodes = {
  WS_MESSAGE_ERROR: 'connectivity:1'
}

/**
 * Error codes for the Presence plugin.
 * @name presenceCodes
 */
export const presenceCodes = {
  INVALID_STATUS: 'presence:1',
  INVALID_ACTIVITY: 'presence:2',
  INVALID_REQUEST: 'presence:3',
  INVALID_PARAM: 'presence:4'
}

/**
 * Error codes for the Users plugin
 * @name usersCodes
 */
export const usersCodes = {
  UNKNOWN: 'users:1',
  REFRESH_CONTACTS_FAIL: 'users:2',
  DIRECTORY_REQUEST_FAIL: 'users:3',
  INVALID_PARAM: 'users:4'
}

/**
 * Error codes for the Webrtc plugin
 * @name webrtcCodes
 */
export const webrtcCodes = {
  INVALID_PARAM: 'webrtc:1'
}
